export const QueryKey = {
	content: 'content',
	products: 'products',
	productTypes: 'product-types',
	attributes: 'attributes',
	attributeValues: 'attribute-values',
	contents: 'contents',
	components: 'components',
	productTypeVariants: 'product-type-variants',
} as const;

export type QueryKey = (typeof QueryKey)[keyof typeof QueryKey];
